import configureApp from 'configureApp';

export const baseUrl = `${configureApp.endpoint.atom}/${configureApp.endpoint.mega_menus}/publish`;
